<template>
  <div class="p-error">
    <h1 class="p-error__heading">
      {{ pageTitle }}
    </h1>
    <section id="content" class="p-error__content" data-testid="error-page">
      <RichText :content="content" />
      <ListOfLinks :links="links" />
      <div v-if="object" class="p-error__image-caption">
        <ImageResponsive
          :id="object?.manifest?.thumbUuid"
          class="p-error__image"
          :image-alt="'asdfa'"
          size="post_inline"
        />
        <!-- image caption -->
        <GuiLink class="p-error__caption" :to="objectTo">
          <!-- Heading for the image-->
          <h4
            v-if="captionHeading"
            ref="heading"
            class="p-error__caption-heading"
            data-testid="imageCaption"
          >
            {{ captionHeading }}
          </h4>
          <p
            v-if="captionSubheading"
            ref="subheading"
            class="p-error__caption-subheading"
          >
            {{ captionSubheading }}
          </p>
        </GuiLink>
      </div>
    </section>
  </div>
</template>

<script>
import { useLocalization } from "@thegetty-private/getty-ui";
import {
  GuiLink,
  ImageResponsive,
  ListOfLinks,
  RichText
} from "@thegetty-private/getty-ui";
import { dataService } from "@thegetty-private/rad-app-utils";
import * as contentHelper from "@/helpers/ContentHelper";
import * as configHelper from "@/helpers/configHelper";

const apiPath = configHelper.getApiPath("/");

export default {
  name: "ErrorPage",
  components: {
    GuiLink,
    ImageResponsive,
    ListOfLinks,
    RichText
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * Visual Item ID
       */
      id: contentHelper.getErrorPageImageObjectId(),
      /**
       * The title of the page
       */
      pageTitle: this.translate("p-error.page_title"),
      /**
       * The text of the error page
       */
      content: this.translate("p-error.content"),
      /**
       * The list of links to display on the error page
       */
      links: contentHelper.getErrorPageLinks(this.translatePart),
      /**
       * Citation
       */
      captionSubheading: contentHelper.getErrorPageImageCaption(),
      /**
       * Elastic search object for error page image
       */
      object: undefined,
      /**
       * Local copy of data service base url
       */
      apiPath: apiPath
    };
  },
  computed: {
    /**
     * Visual item primary name
     */
    captionHeading() {
      return this.object && Object.keys(this.object).length > 0
        ? this.object.primary_name
        : undefined;
    },
    /**
     * Visual item route
     */
    objectTo() {
      if (!this.object?.slug_with_path) {
        return {};
      }
      const slug = this.object.slug_with_path.split("/");
      return {
        name: slug[1],
        params: {
          slug: slug[2]
        },
        state: {
          slug: slug[2],
          id: this.id
        }
      };
    }
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      const data = await dataService.fetchElasticSearchObjects(
        [this.id],
        apiPath
      );
      this.object = data?.[0];
    }
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
